module.exports = __webpack_public_path__ + "img/arrawactive.f1d194eb.png";